"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementErrorBoundary = void 0;
var AgreementModal_1 = require("@CommonFrontend/AgreementView/AgreementModal");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var AgreementErrorBoundary = (function (_super) {
    __extends(AgreementErrorBoundary, _super);
    function AgreementErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.handleReportBug = function () {
            _this.props.onDismiss();
            if (window.Beacon) {
                window.Beacon("open");
                window.Beacon("navigate", "/ask/message/");
            }
        };
        _this.state = { errorMessage: undefined };
        return _this;
    }
    AgreementErrorBoundary.getDerivedStateFromError = function (error) {
        return { errorMessage: error.message };
    };
    AgreementErrorBoundary.prototype.render = function () {
        if (this.state.errorMessage) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(AgreementModal_1.Header, { type: "lite", onDismiss: this.props.onDismiss }),
                react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", justify: "center", gap: "xs", paddingTop: "m", paddingBottom: "m" },
                    react_1.default.createElement(kaleidoscope_1.SVG, { src: "/Assets/icons/block-crash.svg" }),
                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "1" }, "Block Crashed"),
                    react_1.default.createElement(kaleidoscope_1.Text, null, this.state.errorMessage),
                    react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s" },
                        react_1.default.createElement(kaleidoscope_1.Button, { onClick: this.handleReportBug, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Large }, "Report bug"),
                        react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Large, onClick: function () {
                                window.location.reload();
                            } }, "Refresh")))));
        }
        return this.props.children;
    };
    return AgreementErrorBoundary;
}(react_1.default.Component));
exports.AgreementErrorBoundary = AgreementErrorBoundary;
